import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgScreenResolution = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 180 120",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M177 0H3C1.34 0 0 1.34 0 3v114c0 1.66 1.34 3 3 3h174c1.66 0 3-1.34 3-3V3c0-1.66-1.34-3-3-3M6 6h90v54H6zm0 60h93c1.66 0 3-1.34 3-3V6h42v84H6zm168 48H6V96h141c1.66 0 3-1.34 3-3V6h24z" }), /* @__PURE__ */ _jsx("path", { d: "M24 51h6v6h-6zM12 51h6v6h-6zM36 51h6v6h-6zM48 51h6v6h-6zM60 51h6v6h-6zM72 51h6v6h-6zM84 51h6v6h-6z" })]
});
export default SvgScreenResolution;
